import Vue from "vue"
import Router from "vue-router"
import Top from "./components/Top"
import About from "./components/common/About"
import NotFoundComponent from "./components/common/NotFoundComponent"

// Koto
import Summary from "./components/contents/Summary"
import Status from "./components/contents/Status"

Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "top",
            component: Top
        },
        {
            path: "/about",
            name: "about",
            component: About
        },
        // {
        //     path: "/contact",
        //     name: "contact",
        //     component: Contact,
        // },
        {
            path: "/:city/:event",
            name: "summary",
            component: Summary,
            props: true
        },
        {
            path: "/:city/:event/:place",
            name: "status",
            component: Status,
            props: true
        },
        { path: '*', component: NotFoundComponent }
    ]
})